import React, { useEffect, useState } from 'react'
import { BaseLayout } from 'src/layouts'
import styles from './styles.module.scss'
import { RangoSwap } from 'src/components/RangoSwap'
import useAuth from 'src/hooks/useAuth'
import Image from 'next/image'
import { getUserLoyaltyDetails } from 'src/services/userServices'

export const Swap = () => {
  const { isAuthorized } = useAuth()
  const [loyaltyDetails, setLoyaltyDetails] = useState({
    points: 0,
    referralToken: '',
  })

  useEffect(() => {
    if (isAuthorized) {
      getUserLoyaltyDetails()
        .then(response => {
          console.log('User Loyalty Details:', response)
          setLoyaltyDetails(response)
        })
        .catch(error => console.error('Error fetching loyalty details:', error))
    }
  }, [isAuthorized])

  return (
    <BaseLayout>
      <div className={styles.container}>
        <h2>COIN360 Swap - The Best Trades Across All Chains</h2>
        <h4>
          Simplify your token swaps with COIN360, powered by Rango for optimal
          rates and minimal slippage across blockchains.
        </h4>

        {/* <h4>Refer a friend and get 10% of their points accumulated!</h4> */}

        <h5 className={styles.live}>Coin360 Points Season 1 is now live!</h5>

        <p>
          Start earning rewards today — create your account and connect your
          wallet on our{' '}
          <a
            href='https://beta.coin360.com'
            target='_blank'
            rel='noopener noreferrer'
          >
            <span className={styles.link}>New Beta Site</span>
          </a>{' '}
          to track your points and climb the leaderboard!
        </p>

        <RangoSwap />
      </div>
    </BaseLayout>
  )
}

export default Swap
